// extracted by mini-css-extract-plugin
export default {"loader":"classes_loader__DFlbT","icon":"classes_icon__Smf4m","error":"classes_error__MQfhc","button":"classes_button__U8R65"};